import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function fmtEur(n: number): string {
  return new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 0,
  }).format(n);
}

export function fmtUsd(n: number): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: n < 10 ? 2 : 0,
  }).format(n);
}

/** Betrag in beliebiger Währung (EUR für OpenAI Ads), gleiche Rundung wie fmtUsd:
 *  Cent nur unter 10, Symbol vorangestellt wie bei den Dollar-Konten. */
export function fmtMoney(n: number, currency = "USD"): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    maximumFractionDigits: n < 10 ? 2 : 0,
  }).format(n);
}

export function fmtInt(n: number): string {
  return new Intl.NumberFormat("de-DE").format(Math.round(n));
}

/** Handelsvolumen in Lots. Die Betraege sind winzig (0,49 Lots am Tag), deshalb zwei
 *  Nachkommastellen bis 100 und darueber keine — sonst steht dort dauerhaft "0". */
export function fmtLots(n: number): string {
  return new Intl.NumberFormat("de-DE", {
    minimumFractionDigits: n < 100 ? 2 : 0,
    maximumFractionDigits: n < 100 ? 2 : 0,
  }).format(n);
}

export function fmtPct(n: number, digits = 1): string {
  return `${(n * 100).toFixed(digits)}%`;
}

export function relativeTime(iso: string): string {
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return "—";
  const diff = (Date.now() - then) / 1000;
  if (diff < 60) return `${Math.round(diff)}s ago`;
  if (diff < 3600) return `${Math.round(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.round(diff / 3600)}h ago`;
  return `${Math.round(diff / 86400)}d ago`;
}

/** Betrag OHNE Währungszeichen — in den Konto-Kacheln steht das Euro-Icon daneben. */
export function fmtAmount(n: number): string {
  return new Intl.NumberFormat("en-US", { maximumFractionDigits: n < 10 ? 2 : 0 }).format(n);
}
